import React from 'react';

import SoftwareImport from '../../components/Admin/SoftwareImport';

function SoftwareImportView() {
  return (
    <SoftwareImport />
  );
}

export default SoftwareImportView;

